import PropTypes from 'prop-types';
import React from 'react';
import { Pending } from 'components/Profile/Pending';
import { InviteAFriend } from 'features/Reservation/ModalStates/InviteAFriend';
import { schedulesShape } from 'redux/saga/entities/schedules.shape';
export var InviteAFriendModal = function InviteAFriendModal(_ref) {
  var isLoading = _ref.isLoading,
      onModalClose = _ref.onModalClose,
      referral = _ref.referral,
      schedule = _ref.schedule;

  if (isLoading) {
    return React.createElement(Pending, null, React.createElement(Pending.LoadReservation, null));
  }

  if (!schedule) {
    return null;
  }

  return React.createElement(InviteAFriend, {
    eventSource: "Upcoming Page",
    onModalClose: onModalClose,
    referral: referral,
    schedule: schedule
  });
};
InviteAFriendModal.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
  referral: PropTypes.object,
  schedule: schedulesShape
};